import React, { useEffect, useState } from 'react';
// Remove the immediate document.title setting that causes issues
// document.title = "Koottu Admin SignIn";

import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import logoLight from "../../assets/images/KoottuWhite.png";
import { createSelector } from 'reselect';
//import images

const Login = (props) => {
    console.log("Login component rendering");
    
    // Add proper title setting in a useEffect hook
    useEffect(() => {
        document.title = "Koottu Admin SignIn";
    }, []);
    
    const dispatch = useDispatch();
    const selectLayoutState = (state) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Login.user,
            error: state.Login.error,
            loading: state.Login.loading,
            errorMsg: state.Login.errorMsg,
        })
    );
    // Inside your component
    const {
        user, error, loading, errorMsg
    } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState({
        email: "",
        password: ""
    });
    const [passwordShow, setPasswordShow] = useState(false);
    const [loginData, setLoginData] = useState({
        email: '',
        password: ''
    });
    const [validation, setValidation] = useState({
        email: false,
        password: false
    });

    useEffect(() => {
        if (user && user) {
            const updatedUserData = user.user? user.user.email : !loginData.email;
            const updatedUserPassword = user.user? user.user.confirm_password : !loginData.password;
            setUserLogin({
                email: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoginData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear validation error when user types
        setValidation(prev => ({
            ...prev,
            [name]: false
        }));
    };

    const handleLoginClick = () => {
        // Basic validation
        const newValidation = {
            email: !loginData.email,
            password: !loginData.password
        };
        setValidation(newValidation);

        // If any validation error, don't proceed
        if (Object.values(newValidation).some(v => v)) {
            return;
        }

        console.log("Attempting login with:", loginData);
        dispatch(loginUser(loginData, props.router.navigate));
    };

    const signIn = type => {
        dispatch(socialLogin(type, props.router.navigate));
    };

    //handleTwitterLoginResponse
    // const twitterResponse = e => {}

    //for facebook and google authentication
    const socialResponse = type => {
        signIn(type);
    };


    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    // Add console log to check if component is rendering
    console.log("Login component rendered");

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="" height="80" />
                                        </Link>
                                    </div>
                                    <p className="mt-3 fw-medium auth-tagline" style={{ fontSize: "25px", fontFamily: "'Merriweather', serif" }}>
                                        <s>Matrimonial</s>. <s>Dating</s>. Koottu.
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Welcome Back !</h5>
                                            <p className="text-muted">Sign in to continue to Koottu Admin Panel.</p>
                                        </div>
                                        {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    console.log("Form submit event triggered");
                                                    handleLoginClick();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        value={loginData.email}
                                                        onChange={handleInputChange}
                                                        invalid={validation.email}
                                                    />
                                                    {validation.email && (
                                                        <FormFeedback>Please enter email</FormFeedback>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={loginData.password}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={handleInputChange}
                                                            invalid={validation.password}
                                                        />
                                                        {validation.password && (
                                                            <FormFeedback type="invalid">{validation.password}</FormFeedback>
                                                        )}
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button 
                                                        color="success" 
                                                        className="btn btn-success w-100" 
                                                        onClick={handleLoginClick}
                                                    >
                                                        {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                                                        Sign In
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);